// userSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

// Async thunk to fetch user by slug
// Add to features/auth/authSlice.ts

export const updateUserData = createAsyncThunk(
  'userUpdate/updateUserData',
  async (formData: FormData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BACKEND_URL}/update-user-data`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data; // Assumes { message, userData }
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || 'Failed to update user'
      );
    }
  }
);


// Define the shape of user state
interface UserState {
  user: any | null;
  userData: any | null;
  loading: boolean;
  success: boolean;
  error: any | null;
}

const initialState: UserState = {
  user: null,
  userData: null,
  loading: false,
  success: false,
  error: null
};

const userUpdateSlice = createSlice({
  name: 'userUpdate',
  initialState,
  reducers: {
    resetUpdateState: (state) => {
      state.success = false;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.userData = action.payload.userData;

        // Optional: update stored user if needed
        state.user = {
          ...state.user,
          ...action.payload.userData,
        };

        localStorage.setItem('viart_user', JSON.stringify(state.user));
      })
      .addCase(updateUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  }
});

export const { resetUpdateState } = userUpdateSlice.actions;
export default userUpdateSlice.reducer;
